import {
  IconBuilding,
  IconEmployee,
  IconPin,
  IconReserveBox,
  IconShield,
  IconToolWrench
} from '../assets/DesignSystem/SVGComponents';
import { IlogisticServiceLocation, LOCATION_PLACE_TYPE } from '../types/services';

export const getLocationDisplayData = (locationData?: IlogisticServiceLocation | null) => {
  const flag = `url(${locationData?.country?.flag})`;
  switch (locationData?.place) {
    case LOCATION_PLACE_TYPE.USER:
      return { flag, icon: <IconEmployee className="IconEmployee" /> };
    case LOCATION_PLACE_TYPE.OFFICE:
      return { flag, icon: <IconBuilding className="IconBuilding" /> };
    case LOCATION_PLACE_TYPE.OTHER:
      return { flag, icon: <IconPin className="IconPin" /> };
    case LOCATION_PLACE_TYPE.WARRANTY:
      return { flag, icon: <IconShield className="IconShield" /> };
    case LOCATION_PLACE_TYPE.DIAGNOSTIC:
      return { flag, icon: <IconToolWrench className="IconToolWrench" /> };
    case LOCATION_PLACE_TYPE.NUDOS:
      return { flag, icon: <IconReserveBox className="IconReserveBox" /> };
    default:
      return { flag, icon: <IconPin /> };
  }
};
